import { API_HOST } from "./api.js";
import { $ } from "./dom.js";
import { escapeHtml } from "./escape.js";
import { initFaq } from "./faq.js";

const CHEVRON = '<svg class="icon h-5 w-5 shrink-0 text-casto-navy transition-transform duration-300"><use href="#i-chevron"></use></svg>';
const PLUS = '<svg class="icon icon-plus h-4 w-4 shrink-0 text-casto-navy"><use href="#i-plus"></use></svg>';
const MINUS = '<svg class="icon icon-minus h-4 w-4 shrink-0 text-casto-navy"><use href="#i-minus"></use></svg>';

function renderFaqItem(item) {
  return `<div class="faq-item">
    <button class="faq-item__q flex w-full items-center justify-between gap-3 px-3 py-3 text-left text-sm font-medium transition-colors duration-300 hover:text-casto-navy sm:text-base" type="button" aria-expanded="false">
      <span>${escapeHtml(item.question)}</span>
      ${PLUS}
      ${MINUS}
    </button>
    <div class="faq-item__panel"><div class="faq-item__panel-inner"><div class="faq-item__a mx-3 pb-4 space-y-2 rounded-xl bg-casto-cloud/40 p-3">
      <p class="text-xs font-semibold uppercase tracking-wide text-casto-navy">Odpowiedź</p>
      <div class="faq-item__a-html space-y-3 text-sm leading-relaxed text-muted-foreground">${item.answerHtml || ""}</div>
    </div></div></div>
  </div>`;
}

function renderFaqGroup(group, index) {
  const open = index === 0;
  const items = (group.items || []).map(renderFaqItem).join("");
  return `<div class="faq-group overflow-hidden rounded-2xl border border-border bg-white${open ? " is-open" : ""}">
    <button class="faq-group__toggle flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-300 hover:bg-casto-cloud" type="button" aria-expanded="${open}">
      <span class="text-base font-semibold sm:text-lg">${escapeHtml(group.name)}</span>
      ${CHEVRON}
    </button>
    <div class="faq-group__body border-t border-border">
      <div class="faq-group__inner divide-y divide-border px-2 sm:px-3">${items}</div>
    </div>
  </div>`;
}

export async function loadFaq() {
  const root = $("[data-faq-root]");
  if (!root) return;

  // Statyczne FAQ z HTML (develop) działa od razu; API może je podmienić.
  initFaq();

  try {
    const res = await fetch(`${API_HOST}/contractor/faq`);
    if (!res.ok) {
      // np. 403 — zostaw statyczną treść
      return;
    }
    const data = await res.json();
    const groups = data.groups || [];
    if (!groups.length) {
      root.innerHTML = '<p class="text-center text-sm text-muted-foreground">Brak pytań FAQ.</p>';
      return;
    }
    root.innerHTML = groups.map(renderFaqGroup).join("");
    initFaq();
  } catch (err) {
    console.error("FAQ load failed:", err);
  }
}
